import getIsSelectedOneNode from "@ext/markdown/elementsUtils/getIsSelectedOneNode";
import type { Editor } from "@tiptap/react";
import { useEffect, useState } from "react";

export const useIsOneNodeSelected = (editor: Editor) => {
	const [isSelected, setIsSelected] = useState(() => Boolean(editor && getIsSelectedOneNode(editor.state)));

	useEffect(() => {
		if (!editor) return;
		const onSelectionUpdate = ({ editor }: { editor: Editor }) => {
			setIsSelected(getIsSelectedOneNode(editor.state));
		};

		editor.on("selectionUpdate", onSelectionUpdate);
		return () => {
			editor.off("selectionUpdate", onSelectionUpdate);
		};
	}, [editor]);

	return isSelected;
};
